export default "__VITE_ASSET__CifudiqA__"